export default class QuadrantObject {
  static _objectDefinition(_id = "", type = "", _main = false) {
    let _componentId = this._createComponentId(_id, type);
    return {
      tag: "",
      mainMap: _main,
      name: _componentId,
      component: type,
      componentId: _componentId,
      profile: "",
      signalObjectMap: new Map(),
      position: { x: 0, y: 0 },
      hidden: false,
      pinned: true,
    };
  }

  static _createRequestObject(box) {
    console.log("Laurens box", box);

    let reqObj = {
      tag: box.tag,
      name: box.name,
      mainMap: box.mainMap,
      component: box.component,
      componentId: box.componentId,
      profile: box.profile,
      signalObjectMap: [...box.signalObjectMap],
      position: box.position,
      showToolbar: box.showToolbar,
      showBackButton: box.showBackButton,
      location: box.location,
      product: box.product,
      event: box.event,
    };

    return reqObj;
  }

  static _parseDataToObject(data) {
    let obj = this._objectDefinition();
    if (data.hasOwnProperty("tag")) {
      obj.tag = data.tag.value;
    }
    if (data.hasOwnProperty("name")) {
      obj.name = data.name.value;
    }
    if (data.hasOwnProperty("mainMap")) {
      obj.mainMap = data.mainMap.value;
    }
    if (data.hasOwnProperty("component")) {
      obj.component = data.component.value;
    }
    if (data.hasOwnProperty("componentId")) {
      obj.componentId = data.componentId.value;
    } else {
      obj.componentId = this._createPinCode();
    }
    if (data.hasOwnProperty("profile")) {
      obj.profile = data.profile.value;
    }
    if (data.hasOwnProperty("signalObjectMap")) {
      // obj.signalObjectMap = data.signalObjectMap.value;
      obj.signalObjectMap = new Map(data.signalObjectMap.value);
    }
    if (data.hasOwnProperty("position")) {
      obj.position.x = data.position.value.x;
      obj.position.y = data.position.value.y;
    }

    return obj;
  }

  static _createComponentId(_id = "", type = "") {
    return type + "_" + _id;
  }

  static _createPinCode() {
    return Math.random()
      .toString(36)
      .substring(7)
      .toUpperCase();
  }
}

const baseProfile = {
  tag: "",
  default: false,
  style: {
    height: ""
  }
};

function makeBox({
  type = "OperationalScreen_MapQuadrant",
  profile = this.baseProfile,
  signalMap = new Map(),
  location = {},
  tag = "",
  _x = null,
  _y = null,
  paramFlag = false,
  componentId,
  columns,
  rows,
  product,
  event,
}, windowHeight, windowWidth) {
  _x = _x == null ? componentId % columns : _x;
  _y = _y == null ? Math.floor(componentId / columns) : _y;

  let id = profile.default == true ? 0 : componentId++;

  profile.style.height = (windowHeight / rows) + 50 + "px;";
  profile.style.width = (windowWidth / columns) + 50 + "px;";

  if (paramFlag === false) {

    profile.style.height = windowHeight / rows + "px;";
    profile.style.width = windowWidth / columns + "px;";
  } else {
    id = QuadrantObject._createPinCode();
  }
  let _profile = JSON.parse(JSON.stringify(profile));

  let container = QuadrantObject._objectDefinition(id, type, profile.default);

  container.tag = tag;
  container.profile = _profile;
  container.signalObjectMap = new Map(signalMap);
  container.position.x = _x;
  container.position.y = _y;
  container.showToolbar = true;
  container.showBackButton = false;
  container.location = location;
  container.product = product;
  container.event = event;
  return container;
}
export { makeBox };
